<template>
  <div>
    <div class="diagramboxes">
      <diagram-box
        class="diagrambox"
        :heading-translation-key="'ReportTool.totalMemberAmount'"
        :with-diagram-tools="false"
        :diagram-id="data.members.diagramId"
        :comment="data.members.comment">
        <dot-and-doughnut-diagram
          :data="data.members"
          :settings="settings"
          :color-keys="data.colors" />
      </diagram-box>

      <diagram-box
        class="diagrambox"
        :heading-translation-key="'MemberCalculation.membershipGroupDistribution'"
        :with-diagram-tools="true"
        :diagram-id="data.memberGroups.diagramId"
        :comment="data.memberGroups.comment">
        <pie-chart-with-legend
          :data="data.memberGroups.categories.map(t => t.num)"
          :labels="
            data.memberGroups.categories.map(
              t =>
                `${t.memberCategoryName}, ${
                  t.percentage
                }%, ${t.num.toLocaleString('sv-SE')}`
            )
          "
          :percentage="data.memberGroups.categories.map(t => t.percentage)"
          :unit-translation-key="'members'" />
      </diagram-box>

      <diagram-box
        class="diagrambox"
        :heading-translation-key="'MemberCalculation.gameRoundsDistribution'"
        :with-diagram-tools="true"
        :diagram-id="data.gameRounds.diagramId"
        :comment="data.gameRounds.comment">
        <pie-chart-with-legend
          :data="data.gameRounds.categories.map(t => t.num)"
          :labels="
            data.gameRounds.categories.map(
              t =>
                `${t.memberCategoryName}, ${
                  t.percentage
                }%, ${t.num.toLocaleString('sv-SE')}`
            )
          "
          :percentage="data.gameRounds.categories.map(t => t.percentage)"
          :unit-translation-key="'members'" />
      </diagram-box>

      <diagram-box
        class="diagrambox"
        :heading-translation-key="'MemberCalculation.revenueDistribution'"
        :with-diagram-tools="true"
        :diagram-id="data.incomes.diagramId"
        :comment="data.incomes.comment">
        <pie-chart-with-legend
          :data="data.incomes.categories.map(t => t.num)"
          :labels="
            data.incomes.categories.map(
              t =>
                `${t.memberCategoryName}, ${
                  t.percentage
                }%, ${t.num.toLocaleString('sv-SE')}`
            )
          "
          :percentage="data.incomes.categories.map(t => t.percentage)"
          :unit-translation-key="'sek'" />
      </diagram-box>
      <!-- This barchart should be used later in the development -->
      <!-- <diagram-box
        class="diagrambox"
        :heading-translation-key="'MemberCalculation.membershipHistory'"
        :with-diagram-tools="true"
        :diagram-id="data.memberHistory.diagramId"
        :comment="data.memberHistory.comment">
        <bar-chart-with-custom-legend
          :diagram="data.memberHistory"
          :label-translation-keys="data.memberHistory.labelTranslationKeys"
          :legends="legends" />
      </diagram-box> -->
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types';

import LocalizationMixin from '@/mixins/localization-mixin.vue';

// import BarChartWithCustomLegend from '@/components/businessboard/member-calculation/bar-chart-with-custom-legend';
import DiagramBox from '@/components/businessboard/member-calculation/diagram-box';
import DotAndDoughnutDiagram from '@/components/businessboard/member-calculation/dot-and-doughnut-diagram';
import PieChartWithLegend from '@/components/businessboard/pie-chart-with-legend';

export const commentType = VueTypes.shape({
  updateTime: VueTypes.string,
  author: VueTypes.string,
  text: VueTypes.string,
  lastUpdate: VueTypes.string,
  section: VueTypes.number,
  companyId: VueTypes.string,
  canEdit: VueTypes.bool,
  id: VueTypes.string,
});

export default {
  components: {
    // BarChartWithCustomLegend, To be used later in the development
    DiagramBox,
    DotAndDoughnutDiagram,
    PieChartWithLegend,
  },

  mixins: [LocalizationMixin],

  props: {
    data: VueTypes.shape({
      members: VueTypes.shape({
        dataMonth: VueTypes.number,
        comparedToBudget: VueTypes.shape({
          num: VueTypes.number,
          percentage: VueTypes.number,
        }),
        comparedToCurrentMonthLastYear: VueTypes.shape({
          num: VueTypes.number,
          percentage: VueTypes.percentage,
        }),
        comparedToLastMonth: VueTypes.shape({
          num: VueTypes.number,
          percentage: VueTypes.number,
        }),
        diagramId: VueTypes.number,
        juniorMembersComparedToLastYear: VueTypes.shape({
          num: VueTypes.number,
          percentage: VueTypes.number,
        }),
        juniorMembersInPercentage: VueTypes.number,
        seniorMembersComparedToLastYear: VueTypes.shape({
          num: VueTypes.number,
          percentage: VueTypes.number,
        }),
        totalMembers: VueTypes.number,
        colorKeys: VueTypes.arrayOf(VueTypes.string),
        comment: commentType,
        labels: VueTypes.arrayOf(VueTypes.string),
      }),
      memberGroups: VueTypes.shape({
        comment: commentType,
        diagramId: VueTypes.number,
        categories: VueTypes.arrayOf({
          memberTypeName: VueTypes.string,
          num: VueTypes.number,
          percentage: VueTypes.number,
        }),

        data: VueTypes.arrayOf(VueTypes.number),
      }),
      gameRounds: VueTypes.shape({
        comment: commentType,
        diagramId: VueTypes.number,
        categories: VueTypes.arrayOf({
          memberTypeName: VueTypes.string,
          num: VueTypes.number,
          percentage: VueTypes.number,
        }),

        data: VueTypes.arrayOf(VueTypes.number),
      }),
      incomes: VueTypes.shape({
        comment: commentType,
        diagramId: VueTypes.number,
        categories: VueTypes.arrayOf({
          memberTypeName: VueTypes.string,
          num: VueTypes.number,
          percentage: VueTypes.number,
        }),

        data: VueTypes.arrayOf(VueTypes.number),
      }),
      memberHistory: VueTypes.shape({
        comment: commentType,
        comparisonYear: VueTypes.shape({
          actual: VueTypes.arrayOf(VueTypes.number),
          budgeted: VueTypes.number,
          year: VueTypes.number,
        }),
        currentYear: VueTypes.shape({
          actual: VueTypes.arrayOf(VueTypes.number),
          budgeted: VueTypes.number,
          year: VueTypes.number,
        }),
        diagramId: VueTypes.number,
        labels: VueTypes.arrayOf(VueTypes.string),
      }),
      legends: VueTypes.arrayOf({
        style: VueTypes.string,
        type: VueTypes.string,
      }),
    }),
    legends: VueTypes.arrayOf({}),
    settings: VueTypes.shape({
      currentYear: VueTypes.number,
      comparisonYear: VueTypes.number,
      imageFormat: VueTypes.number,
      persist: VueTypes.bool,
      availableYears: VueTypes.arrayOf(VueTypes.number),
    }),
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.diagramboxes {
  display: grid;
  grid-template-columns: repeat(3, minmax(300px, 1fr));
  grid-gap: 1rem;

  margin: 1rem 0;
}
</style>
